import { SVGProps } from "react";

export type IconSvgProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export enum AvailableRoles {
  TUTOR = "tutor",
  STUDENT = "student",
}

export type GoogleCalendarConnectionStatus =
  | "not_connected"
  | "connected_healthy"
  | "requires_reauth";

export interface GetUserDataResponse {
  id: string;
  first_name: string | null;
  last_name: string | null;
  avatar_url: string | null;
  full_name: string | null;
  role: AvailableRoles;
  is_onboarded: boolean;
  permissions: string[];
  special_role_checks: {
    has_subscription: boolean;
    has_public_profile: boolean;
    has_payments_setup: boolean;
    has_default_pricing: boolean;
    payment_plan: string;
    payment_plan_status: string;
    google_calendar: GoogleCalendarConnectionStatus;
  };
  timezone: string;
}
